module.exports = __webpack_public_path__ + "img/characters_Philip.6db4f644.png";